import { z } from 'zod';
import { NumericalIdSchema } from './commonTypes';
export var NotificationIdSchema = NumericalIdSchema;
export var NotificationStatusesSchema = z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3)
]);
export var NotificationSchema = z.object({
    id: z.union([z.string(), z.number()]),
    status: z.union([z.number(), NotificationStatusesSchema]),
    notification_type_id: z.number().optional(),
    user_id: z.union([z.string(), z.number()]).optional(),
    game_id: z.union([z.string(), z.number()]).optional(),
    game_name: z.string().optional(),
    creator_name: z.string().optional(),
    body: z.string().optional()
});
